import React, { useRef, useEffect } from "react";
import OtpInput from "react-otp-input";
import styled from "styled-components";
const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
};
const StyledOtpInput = styled(OtpInput).attrs()`
  .otp-input:nth-child(1) {
    margin-left: 0px;
  }
  .otp-input:nth-child(5) {
    margin-right: 0px;
  }
  .otp-input {
    width: 58px !important;
    height: 58px;
    text-align: center;
    color: ${(props) => props.theme.palette.dark.c300};
    font-size: 24px;
    font-weight: 500;
    border-radius: 4px;
    border: 1px solid;
    border-color: ${(props) =>
      props.error
        ? props.theme.palette.red.c300
        : props.theme.palette.dark.c100};

    &:focus {
      border: 2px solid;
      border-color: ${(props) => props.theme.palette.primary.c03};
    }
    .otp-first-input {
      width: 58px;
      height: 58px;
      text-align: center;
      margin: 0 10px;
      color: ${(props) => props.theme.palette.dark.c300};
      font-size: 24px;
      font-weight: 500;
      border-color: ${(props) => props.theme.palette.red.c300};
      border-radius: 4px;
    }
  }
`;

const OtpInputFields = ({
  onComplete,
  otp,
  otpAutoFocusTrigger,
  triggerFocus,
  className,
  error,
}) => {
  const updateOtp = (otp) => {
    onComplete(otp);
  };

  const innerRef = useRef();
  useEffect(() => {
    setTimeout(() => {
      innerRef.current && innerRef.current.focusInput(0);
    }, 20);
    if (otpAutoFocusTrigger === true) {
      triggerFocus();
    }
  }, [otpAutoFocusTrigger]);

  return (
    <div className={`otpInput ${className ? className : ""} mx-0`}>
      <div className="d-flex w-100">
        <StyledOtpInput
          value={otp}
          isInputNum={true}
          onChange={(e) => updateOtp(e)}
          numInputs={6}
          shouldAutoFocus={true}
          inputStyle="otp-input"
          ref={innerRef}
          error={error}
          containerStyle={containerStyle}
        />
      </div>
    </div>
  );
};

export default OtpInputFields;
